module.exports = __webpack_public_path__ + "img/doors_gray.1898323e.svg";